import Vue from "vue";

export default {
  bind(el, binding, vnode) {
    Vue.nextTick(function () {
      vnode.elm.querySelector("input").focus();
    });
  },
};
